<template>
  <v-app>
    <AppBar />

    <v-main>
      <v-container>
        <router-view/>
      </v-container>
    </v-main>

    <v-footer
      color="grey darken-3"
      padless
    >
      <v-row
        justify="center"
        no-gutters
      >
        <v-btn
          v-for="link in footer_links"
          :key="link.to"
          color="white"
          text
          class="my-2"
          rounded
          :to="link.to"
        >
          {{ link.text }}
        </v-btn>

        <v-btn
          color="white"
          text
          class="my-2"
          rounded
          href="https://gw.acri.c.titech.ac.jp/wp/forums/forum/hls-challenge"
        >
          フォーラム
        </v-btn>

        <v-col
          class="py-4 text-center white--text"
          cols="12"
        >
          2021 - <strong>ACRi</strong>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import AppBar from '@/components/AppBar';

export default {
  name: 'App',
  components: {
    AppBar,
  },
  data: () => ({
    footer_links: [
      { to: "/about",   text: "このサイトについて" },
      { to: "/tos",     text: "利用規約" },
      { to: "/privacy", text: "プライバシーポリシー" },
    ],
  }),
  methods : {
    createTitleDesc : function(routeInstance) {
      let title = "ACRi HLSチャレンジ"
      if (routeInstance.meta.title) {
        title += " - " + routeInstance.meta.title
      }
      document.title = title;
    }
  },
};
</script>
